import { Deserializable } from '../../protocols/deserializable';

export class AnnuityOperationalConversionRateResponse implements Deserializable {
  public id!: number;
  public operationalRateId!: number;
  public month!: number;
  public rate!: number;

  public onDeserialize(): void {}
}
